import { render, staticRenderFns } from "./Template28.vue?vue&type=template&id=63a6d957&scoped=true&"
import script from "./Template28.vue?vue&type=script&lang=js&"
export * from "./Template28.vue?vue&type=script&lang=js&"
import style0 from "./Template28.vue?vue&type=style&index=0&id=63a6d957&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a6d957",
  null
  
)

export default component.exports